import React, { Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import { SelectListWithLabel, QuestionSelection } from "../../components/custom-report"
import { ReportSelectedOptionsShape, ReviewDataShape } from "../../state/shapes/CustomReportShapes"

function ReviewExport({
  appraisalLevels,
  onReviewChanged,
  onAppraisalLevelChanged,
  reviews,
  reviewData,
  t,
  reportSelection
}) {
  const initialSelectionForReviews = {
    text: t("CustomReport.Reviews.SelectReview"),
    id: -1,
    disabled: true
  }
  const initialSelectionForAppraisalLevels = {
    text: t("CustomReport.AppraisalLevels.SelectLevel"),
    id: -1
  }

  return (
    <Fragment>
      <SelectListWithLabel
        label={`${t("Filters.Standard.Review.Name")} *`}
        data={reviews}
        onChange={onReviewChanged}
        initialSelection={initialSelectionForReviews}
        selectedValue={reportSelection.reviewId}
      />

      {appraisalLevels.length > 0 ? (
        <SelectListWithLabel
          label={t("Filters.Standard.AppraisalLevels.Name")}
          data={appraisalLevels}
          onChange={onAppraisalLevelChanged}
          initialSelection={initialSelectionForAppraisalLevels}
          selectedValue={reportSelection.appraisalLevelId}
          sortAlphabetically
        />
      ) : null}
      <QuestionSelection reviewData={reviewData} />
    </Fragment>
  )
}

function mapStateToProps(state) {
  return {
    reportSelection: state.reportSelection
  }
}

ReviewExport.propTypes = {
  appraisalLevels: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  ).isRequired,
  onReviewChanged: PropTypes.func.isRequired,
  onAppraisalLevelChanged: PropTypes.func.isRequired,
  reviews: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  ).isRequired,
  reviewData: PropTypes.shape(ReviewDataShape),
  t: PropTypes.func.isRequired,
  reportSelection: PropTypes.shape(ReportSelectedOptionsShape).isRequired
}

ReviewExport.defaultProps = {
  reviewData: null
}

export default compose(translate(), connect(mapStateToProps))(ReviewExport)



// WEBPACK FOOTER //
// ./src/components/custom-report/ReviewExport.jsx